import { m } from 'framer-motion';
import Image from 'next/image';

const MotionImage = m(Image);

export default MotionImage;
